module.exports = __webpack_public_path__ + "static/img/szafa_6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_6.svg
// module id = 4nlW
// module chunks = 0